export default {
    setBet(state, betData) {
        state.betData = betData;
    },
    setBetDataByKey(state, { key, value }) {
        state.betData[key] = value;
    },
    setRates(state, rates) {
        state.rates = [...rates];
    },
};
